//** Toggle the main header actions if main navigation is sticky **//

import eventBus from "./event-bus";

const el = document.querySelector('.is-js-main-navigation-bar');

if (el) {

    const observer = new IntersectionObserver(
        ([e]) => {
            e.target.classList.toggle('is-pinned', e.intersectionRatio < 1);
            if (el.classList.contains('sticky')) {
                document.querySelector('.is-header').classList.toggle('is-pinned', e.intersectionRatio < 1);
                document.querySelector('body').classList.toggle('is-pinned', e.intersectionRatio < 1);
                document.querySelector('[data-role="sticky-header-action-bar"]').classList.toggle('d-none', !(e.intersectionRatio < 1));
                eventBus.emit('pinned', null, e.intersectionRatio < 1);
            }


        },
        {threshold: [1]}
    );

    observer.observe(el);

}
